// import library
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);

const BarChart = ({chartData}) => {
    const { t } = useTranslation();
    const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        notation: "compact",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        currency: 'EUR',
        currencyDisplay: 'narrowSymbol'
    });

    // variables
    const labels = chartData[0];
    const data = {
        labels: labels,
        datasets: [
            {
                label: `${ t("revenue")}`,
                indexAxis : 'y',
                data: chartData[1],
                backgroundColor: chartData[2],
                barPercentage: 0.3,
                borderRadius: 8,
            },
        ],
    };
    
    const options = {
        plugins: {
            responsive: true,
            legend: {
                display: false,
            },
            datalabels: {
                anchor: "end",
                align: "end",
                font: {
                    weight: 'bold'
                },
                color: '#000',
                formatter: function(value, context) {
                    return `${formatter.format(value)}`;
                },
            },
        },
    }

    return (
        <div>
            <Bar data={data} options={options} height={50} width={50}/>
        </div>
    );
};

export default BarChart;